export default "__VITE_ASSET__25qPv4UC__"